export default {
  apartments: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Apartment buildings & real estate',
    hero: {
      eyebrow: 'Apartment buildings & real estate',
      title: 'Security for entire residential buildings',
      lead: 'Entrance, stairwell, underground garage – we plan surveillance for apartment buildings that protects tenants and gives owners peace of mind.',
    },
    areas: {
      title: 'Surveillance points in apartment buildings',
      lead: 'Communal areas are the most important starting points. We always respect the rights of all residents.',
      items: {
        '0': { title: 'Building entrance', desc: 'The entrance is the building’s calling card – and the most important surveillance point. Cameras capture who enters.' },
        '1': { title: 'Stairwell', desc: 'Stairwells are transitions with lots of movement. Compact cameras close the gaps between floors unobtrusively.' },
        '2': { title: 'Bicycle cellar', desc: 'Bicycles and e-bikes are popular theft targets. Surveillance in the cellar deters and helps with clarification.' },
        '3': { title: 'Outdoor area', desc: 'Playgrounds, green spaces and paths belong to the communal area. Weatherproof cameras protect here too.' },
        '4': { title: 'Underground garage', desc: 'Parking spaces in the underground garage are particularly at risk at night. Well-lit surveillance creates safety.' },
        '5': { title: 'Mailbox area', desc: 'Mailboxes and parcel lockers are the hub for parcel theft. Cameras at the access help noticeably.' },
      },
    },
    protection: {
      eyebrow: 'Data protection & house rules',
      title: 'Monitor without violating',
      lead: 'Many interests come together in an apartment building. We implement surveillance so it respects residents’ privacy – and is legally clean.',
      items: {
        '0': { title: 'Privacy masking', desc: 'Windows, apartment doors and private areas are technically hidden – only communal areas remain in the image.' },
        '1': { title: 'Resolution & house rules', desc: 'Video surveillance in apartment buildings needs a solid basis. We support you with clean implementation.' },
        '2': { title: 'Signage', desc: 'Clear notices at the entrance inform tenants and visitors – transparent, fair and legally recommended.' },
      },
    },
    value: {
      eyebrow: 'Added value',
      title: 'Advantages for owners and managers',
      lead: 'A well thought-out system pays off for everyone: tenants feel safer, owners protect their asset and managers get clarity on incidents.',
      list: {
        '0': 'Access for managers and owners with separate user rights',
        '1': 'Recording of the last days to weeks – depending on storage configuration',
        '2': 'Relief for property management in incidents and disputes',
        '3': 'Complete documentation in case of vandalism or burglary',
        '4': 'Deterrence for unauthorised access',
        '5': 'A greater sense of security for tenants and owners',
      },
      note: 'Note: The legal admissibility of video surveillance in residential buildings depends heavily on the individual case. We advise you, but do not replace legal advice.',
    },
    cta: {
      title: 'More security for your building',
      lead: 'We advise owner associations and managers without obligation – from the first idea to the turnkey system.',
      primary: 'Arrange a consultation',
      secondary: 'Start the Camera Planner',
    },
  },
};